document.addEventListener('DOMContentLoaded', function () {
  const blocks = document.querySelectorAll('.block-hero-holding');

  if (!blocks.length) return;

  function updateBlockMediaOffset(block) {
    const inner = block.querySelector('.block-hero-holding__inner');

    if (!inner) return;

    if (window.innerWidth < 768) {
      block.style.setProperty('--hero-media-offset-right', '0px');
      return;
    }

    const innerRect = inner.getBoundingClientRect();
    const innerStyles = window.getComputedStyle(inner);
    const paddingRight = parseFloat(innerStyles.paddingRight) || 0;
    const offsetRight = Math.max(window.innerWidth - innerRect.right + paddingRight, 0);
    block.style.setProperty('--hero-media-offset-right', `${offsetRight}px`);
  }

  function updateAllBlocks() {
    blocks.forEach(updateBlockMediaOffset);
  }

  updateAllBlocks();

  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateAllBlocks, 100);
  });
});
